import React from 'react'
import Footer from './Footer'
import Topbar from './Topbar'
import github from './resources/github-mark.svg'
import linkedin from './resources/linkedin.svg'
import { EnvelopeIcon } from '@heroicons/react/24/solid'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'

export default function IdeaInspiration() {
  var [registrations, setRegistrations] = React.useState([])

  React.useEffect(() => {
    getRegistrations().then((data) => {
      console.log(data)
      setRegistrations(data)
    })
  }
  , [])

  function getRegistrations() {
    return fetch('http://localhost:8000/idea_registration',
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          // 'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      }
    )
      .then((response) => response.json())
      .then((data) => data)
  } 

  function searchIdeas(query) {
      return fetch('http://localhost:8000/search_registration?query=' + query,
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log('registration data: ')
          console.dir(data)
          setRegistrations(data)
        })  
  }

  function handleKeyPress(event) {
    const query = event.target.value

    if (event.key === 'Enter') {
      if (query === undefined || query === null || query === '') {
        getRegistrations().then((data) => {
          console.log(data)
          setRegistrations(data)
        })
      } else {
        searchIdeas(query)
      }
    }
  }

  return (
    <div>
      <Topbar />
    
    <div className="bg-white py-24 sm:py-16">
    <div className="mt-4 px-12 flex">
        <div className="-mr-px grid grow grid-cols-1 focus-within:relative">
          <input
            id="query"
            name="query"
            onKeyDown={handleKeyPress}
            type="text"
            placeholder="Find your inspiration . . ."
            className="col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pl-10 pr-3 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:pl-9 sm:text-sm/6"
          />
          <MagnifyingGlassIcon
            aria-hidden="true"
            className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4"
          />
        </div>
      </div>

    {registrations != null && registrations.map((registration, index) => (
    <div className="pt-8 px-12 lg:col-start-3 lg:row-end-1">
      <h2 className="sr-only">Summary</h2>
      <div className="rounded-lg bg-gray-50 shadow-sm ring-1 ring-gray-900/5">
        <dl className="flex flex-wrap">
          <div className="flex-auto pl-6 pt-6">
            <dt className="text-sm/6 font-semibold text-gray-900">{registration.ideaname}</dt>
            <dd className="mt-1 text-base text-gray-900">{registration.summary}</dd>
          </div>
          <div className="flex-none self-end px-6 pt-4">
            <dt className="sr-only">Status</dt>
            <dd className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
              Patent Status: Pending
            </dd>
          </div>
          <div className="mt-6 flex w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6">
            <dt className="flex-none">
              <span className="sr-only">Primary Contact</span>
              <EnvelopeIcon aria-hidden="true" className="h-6 w-5 text-gray-400" />
            </dt>
            <dd className="text-sm/6 font-medium text-gray-900">{registration.first_name} {registration.last_name} : {registration.email}</dd>
          </div>
          <div className="mt-4 flex w-full flex-none gap-x-4 px-6">
            <dt className="flex-none">
              <span className="sr-only">Repository</span>
              <img src={github} alt="Github" className="h-5 w-5 fill-current text-gray-400" />
            </dt>
            <dd className="text-sm/6 text-gray-500">
              {/* <time dateTime="2023-01-31">{registration.github_profile}</time> */}
              <a href={registration.github_profile} target="_blank" rel="noopener noreferrer">{registration.github_profile}</a>
            </dd>
          </div>
          <div className="mt-4 flex w-full flex-none gap-x-4 px-6">
            <dt className="flex-none">
              <span className="sr-only">Status</span>
              <img src={linkedin} alt="LinkedIn" className="h-5 w-5 fill-current text-gray-400" />
            </dt>
            <dd className="text-sm/6 text-gray-500"><a href={registration.linkedin_profile} target="_blank" rel="noopener noreferrer">{registration.linkedin_profile}</a></dd>
          </div>
        </dl>
        <div className="mt-6 border-t border-gray-900/5 px-6 py-6">
          <a href="/" className="text-sm/6 font-semibold text-gray-900">
            Download Abstract <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </div>
    </div>
  ))}
</div>
      <Footer />
    </div>
  )
}
